/** Máximo de fotos no checklist (evita PDF enorme / travamento no navegador). */
export const CHECKLIST_MAX_PHOTOS = 14;

/** Tipos MIME aceitos no input file (browser costuma falhar em HEIC aqui). */
export const CHECKLIST_IMAGE_ACCEPT = 'image/jpeg,image/png,image/webp';

export function fileToDataUri(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => {
      const result = r.result;
      if (typeof result === 'string') resolve(result);
      else reject(new Error('Leitura do arquivo incompleta.'));
    };
    r.onerror = () => reject(r.error ?? new Error('Não foi possível ler o arquivo.'));
    r.readAsDataURL(file);
  });
}

/**
 * Converte para JPEG via canvas — o `@react-pdf/renderer` usa PDFKit, que não trata bem WebP
 * em data URIs (fotos somem no PDF, muitas vezes sem erro no console).
 * Redimensiona o lado maior para no máximo `maxSide` px.
 */
export function normalizeImageToJpegDataUri(file: Blob, maxSide = 1680, quality = 0.88): Promise<string> {
  return new Promise((resolve, reject) => {
    const blobUrl = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(blobUrl);
      try {
        let w = img.naturalWidth;
        let h = img.naturalHeight;
        if (!w || !h) {
          reject(new Error('Não foi possível ler dimensões da imagem.'));
          return;
        }
        if (w > maxSide || h > maxSide) {
          if (w >= h) {
            h = Math.round((h * maxSide) / w);
            w = maxSide;
          } else {
            w = Math.round((w * maxSide) / h);
            h = maxSide;
          }
        }
        const canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        const ctx = canvas.getContext('2d');
        if (!ctx) {
          reject(new Error('Canvas não disponível neste navegador.'));
          return;
        }
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, w, h);
        ctx.drawImage(img, 0, 0, w, h);
        const jpeg = canvas.toDataURL('image/jpeg', quality);
        if (!jpeg.startsWith('data:image/jpeg')) {
          reject(new Error('Falha ao gerar JPEG para o PDF.'));
          return;
        }
        resolve(jpeg);
      } catch (e) {
        reject(e instanceof Error ? e : new Error('Erro ao processar a imagem.'));
      }
    };
    img.onerror = () => {
      URL.revokeObjectURL(blobUrl);
      reject(new Error('Não foi possível carregar a imagem para o PDF.'));
    };
    img.src = blobUrl;
  });
}
